import React, { useState } from 'react';
import styled from 'styled-components';
import { Poppins, Spacer } from 'src/common';
import Button from '../form/Button';
import { gaEventEXPORT } from 'src/utils/gaEvent';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { useExportJob } from 'src/hooks/useExportJob';
import { ExportAccessToggle, Modal } from './comps';

const StyledModal = styled(Modal)`
  width: 566px;
  min-height: 200px;
  overflow-y: auto;
  max-height: 100%;
  padding: 0 !important;

  .container {
    display: grid;
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.stroke};
  }
`;

interface PdfExportModalInsightsProps {
  onClose: () => void;
  assessmentId: string;
}

export const PdfExportModalInsights: React.FC<PdfExportModalInsightsProps> = ({ onClose, assessmentId }) => {
  const [isPublic, setIsPublic] = useState(true);
  const { triggerExport, loading } = useExportJob({ onClose });

  return (
    <StyledModal onRequestClose={() => onClose()} isOpen isLoading={loading} persistent={loading}>
      <Spacer $px={54} />
      <div className="h-padding">
        <Poppins className="m-title" px={28}>
          Export PDF
        </Poppins>
      </div>
      <Spacer $px={15} />
      <div className="divider" />
      <Spacer $px={24} />
      <div className="h-padding">
        <ExportAccessToggle value={isPublic} onChange={setIsPublic} />
        <Spacer $px={32} />
        <div className="container">
          <Button
            disabled={loading}
            loading={loading}
            primary
            onClick={() => {
              gaEventEXPORT('EXPORT_PDF');
              mpEvent(MPEvents.ButtonClick, {
                button: 'Export',
                modal: 'Pdf export modal',
              });
              triggerExport(
                {
                  type: 'insights',
                  format: 'pdf',
                  assessmentId,
                },
                { isPublic },
              );
            }}
            data-cy="export"
          >
            EXPORT
          </Button>
        </div>
      </div>
      <Spacer $px={47} />
    </StyledModal>
  );
};
